import React from 'react'
import { CollectionType } from '../../types'
import { CollectionBlock } from './CollectionBlock'

interface Props {
  collection: CollectionType
}

export const Collection: React.FC<Props> = ({ collection }) => (
  <div className="collectionblocks __archive">
    <h2 className="collectionblocks-title">{collection.title}</h2>
    <div className="collectionblocks-blocks">
      <div className="row">
        {collection.collection_blocks.map(block => (
          <CollectionBlock key={block.title} block={block} />
        ))}
      </div>
    </div>
  </div>
)
